import { render, staticRenderFns } from "./OrderContents.vue?vue&type=template&id=bac8fec0&scoped=true"
import script from "./OrderContents.vue?vue&type=script&lang=js"
export * from "./OrderContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac8fec0",
  null
  
)

export default component.exports